(() => {
  const priority = [
    'Quality', 'Type', 'Design Option', 'Jewelry State',
    'Primary Stone Type', 'Primary Stone Shape',
    'Primary Stone Size', 'Secondary Stone Type',
    'Finished State', 'Description'
  ];

  const labels = {
    'Quality': 'Metal',
    'Jewelry State': 'Stones included',
    'Primary Stone Type': 'Included center stone type',
    'Primary Stone Shape': 'Center stone shape / setting shape',
    'Primary Stone Size': 'Center stone size / setting size',
    'Secondary Stone Type': 'Included accent stone type'
  };

  const display = v =>
    v === 'N/A' ? 'Not included / not applicable' :
    v === 'Unset' ? 'Unset — no stones set' :
    v === 'Semi-Set' ? 'Semi-set — review configuration details' :
    v;

  function mount(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const area = root.querySelector('[data-options]');
    const detail = root.querySelector('[data-details]');
    const submit = root.querySelector('[data-submit]');
    const cartStatus = root.querySelector('[data-cart-status]');
    const variantInput = root.querySelector('[data-variant-id]');
    const form = root.querySelector('[data-cart-form]');

    let selected;
    let variant;
    let revision = 0;
    let adding = false;

    const commerce = new window.StullerCommerce({
      route: window.Shopify?.routes?.root || '/'
    });

    fetch(root.dataset.url)
      .then(r => {
        if (!r.ok) throw Error();
        return r.json();
      })
      .then(rows => {
rows = rows.filter(row => {
  const is127306 =
['127306', '689773'].includes(String(row.options?.Series));

  if (is127306) {
    return (
      row.options?.Product === 'Engagement Ring' &&
      row.options?.['Jewelry State'] === 'Unset'
    ) || row.options?.Product === 'Band';
  }

  return (
    row.options?.['Jewelry State'] === 'Semi-Set' &&
    row.includedCenter === false
  );
});

if (!rows.length) {
  throw Error('No configurations available');
}
        const rowCurrency = rows[0]?.currency || 'USD';
        const wanted = new URL(location.href).searchParams.get('stuller_sku');

        const allKeys = [
          ...new Set(rows.flatMap(r => Object.keys(r.options)))
        ].filter(k => k !== 'Series');

        const keys = [
          ...priority.filter(k => allKeys.includes(k)),
          ...allKeys.filter(k => !priority.includes(k))
        ].filter(k =>
          new Set(
            rows.map(r => r.options[k] || 'Not applicable')
          ).size > 1
        );

        const initial =
          rows.find(r => r.sku === wanted) ||
          rows.find(r =>
            /^engagement ring$/i.test(
              String(r.options?.Product || '').trim()
            )
          ) ||
          rows[0];

        const selects = keys.map(k => {
          const label = document.createElement('label');
          label.append(labels[k] || k);

          const select = document.createElement('select');
          select.dataset.key = k;

          if (initial) {
            select.dataset.initial =
              initial.options[k] || 'Not applicable';
          }

          label.append(select);
          area.append(label);
          return select;
        });

        function update() {
          let candidates = rows;

          selects.forEach(select => {
            const old = select.value || select.dataset.initial;
            delete select.dataset.initial;

            const values = [
              ...new Set(
                candidates.map(r =>
                  r.options[select.dataset.key] || 'Not applicable'
                )
              )
            ].sort((a, b) =>
              a.localeCompare(b, undefined, { numeric: true })
            );

            select.replaceChildren(
              ...values.map(v => new Option(display(v), v))
            );

            if (values.includes(old)) select.value = old;

            if (select.dataset.key === 'Primary Stone Shape') {
              let icons = select.parentElement.querySelector('.dl-shapes');

              if (!icons) {
                icons = document.createElement('div');
                icons.className = 'dl-shapes';
                select.parentElement.append(icons);
              }

              icons.replaceChildren(...values.map(value => {
                const button = document.createElement('button');
                button.type = 'button';

                const namespace = 'http://www.w3.org/2000/svg';
                const symbol = document.createElementNS(namespace, 'svg');

                symbol.setAttribute('viewBox', '0 0 40 40');
                symbol.setAttribute('width', '28');
                symbol.setAttribute('height', '28');
                symbol.setAttribute('aria-hidden', 'true');

                const oval = /round|oval/i.test(value);
                const shape = document.createElementNS(
                  namespace,
                  oval ? 'ellipse' : 'polygon'
                );

                if (oval) {
                  shape.setAttribute('cx', '20');
                  shape.setAttribute('cy', '20');
                  shape.setAttribute('rx', /round/i.test(value) ? '15' : '11');
                  shape.setAttribute('ry', '15');
                } else {
                  shape.setAttribute(
                    'points',
                    /pear/i.test(value)
                      ? '20,3 33,22 30,33 20,37 10,33 7,22'
                      : /marquise/i.test(value)
                        ? '20,2 31,20 20,38 9,20'
                        : /heart/i.test(value)
                          ? '20,10 29,4 37,12 34,23 20,37 6,23 3,12 11,4'
                          : '10,4 30,4 36,10 36,30 30,36 10,36 4,30 4,10'
                  );
                }

                shape.setAttribute('fill', 'none');
                shape.setAttribute('stroke', 'currentColor');
                shape.setAttribute('stroke-width', '1.5');

                symbol.append(shape);
                button.append(symbol, document.createTextNode(value));
                button.setAttribute(
                  'aria-pressed',
                  String(value === select.value)
                );

                button.onclick = () => {
                  select.value = value;
                  update();
                };

                return button;
              }));
            }

            candidates = candidates.filter(r =>
              (r.options[select.dataset.key] || 'Not applicable') ===
              select.value
            );
          });

          let skuSelect = area.querySelector('[data-sku]');

          if (!skuSelect) {
            const label = document.createElement('label');
            label.textContent = 'Catalog configuration';

            skuSelect = document.createElement('select');
            skuSelect.dataset.sku = '';

            label.append(skuSelect);
            area.append(label);

            skuSelect.addEventListener('change', () => {
              show(rows.find(r => r.sku === skuSelect.value));
            });
          }

          const old = skuSelect.value || wanted;

          skuSelect.replaceChildren(...candidates.map(row =>
            new Option(
              row.sku + ' — ' +
              new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: rowCurrency
              }).format(Number(row.price)),
              row.sku
            )
          ));

          if (candidates.some(r => r.sku === old)) {
            skuSelect.value = old;
          }

          show(candidates.find(r => r.sku === skuSelect.value));
        }

        function show(row) {
          selected = row;
          variant = null;

          const token = ++revision;

          variantInput.value = '';
          variantInput.disabled = true;
          root.querySelector('[data-confirm]').checked = false;
          detail.replaceChildren();
          submit.disabled = true;
          cartStatus.textContent = '';

          if (!row) return;

          const price = document.createElement('p');
          price.className = 'dl-price';
          price.textContent = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: rowCurrency
          }).format(Number(row.price));

          detail.append(price);

          const paragraphs = [
            row.description,
            row.inclusionSummary,
            'SKU: ' + row.sku,
            'Supplier catalog status: ' + row.status,
            ...Object.entries(row.options).map(([key, value]) =>
              (labels[key] || key) + ': ' + display(value)
            ),
            row.ready
              ? 'Ready-to-wear catalog configuration.'
              : 'This configuration is not marked ready to wear. Confirm the center stone and setting work with us.',
            'Choose your ring size below.'
          ];

          paragraphs.forEach(text => {
            const p = document.createElement('p');
            p.textContent = text;
            detail.append(p);
          });

          const specs = root.querySelector('[data-specs]');
          specs.replaceChildren();

          Object.entries(row.details || {}).forEach(([key, value]) => {
            const dt = document.createElement('dt');
            const dd = document.createElement('dd');

            dt.textContent = key.replace(/([a-z])([A-Z])/g, '$1 $2');
            dd.textContent = key === 'OnHand'
              ? value + ' (supplier stock; availability must be confirmed)'
              : value;

            specs.append(dt, dd);
          });

          const frame = root.querySelector('[data-video-frame]');
          const video = root.querySelector('[data-video]');
          const img = root.querySelector('[data-image]');
          const gallery = root.querySelector('[data-gallery]');

          frame.hidden = true;
          frame.removeAttribute('src');
          video.pause();
          video.hidden = true;
          video.removeAttribute('src');

          function showImage(url) {
            frame.hidden = true;
            frame.removeAttribute('src');
            video.pause();
            video.hidden = true;
            img.hidden = false;
            img.src = url;
          }

          img.alt = row.description || '';
          const images = row.images || [];

          if (images.length) {
            showImage(images[0]);
          } else {
            img.hidden = true;
            img.removeAttribute('src');
          }

          gallery.replaceChildren(...images.map((url, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute(
              'aria-label',
              'View ring angle ' + (index + 1)
            );

            const thumb = document.createElement('img');
            thumb.src = url;
            thumb.alt = '';

            button.append(thumb);
            button.onclick = () => showImage(url);
            return button;
          }));

          (row.mountingImages || []).slice(0, 1).forEach(url => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = 'Mounting';
            button.onclick = () => showImage(url);
            gallery.append(button);
          });

          const videos = [
            ...new Set([row.video, row.groupVideo].filter(Boolean))
          ];

          videos.forEach((url, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = videos.length === 1
              ? '360° video'
              : '360° video ' + (index + 1);

            button.setAttribute(
              'aria-label',
              'Play configuration video ' + (index + 1)
            );

            button.onclick = () => {
              video.pause();
              frame.removeAttribute('src');
              frame.hidden = true;
              img.hidden = true;

              if (index === 0 && row.videoFile) {
                video.hidden = false;
                video.src = row.videoFile;
                video.play().catch(() => {});
              } else {
                video.hidden = true;
                frame.src = url;
                frame.hidden = false;
              }
            };

            gallery.append(button);
          });

          commerce.resolve(row)
            .then(verified => {
              if (token !== revision) return;

              variant = verified;
              variantInput.value = String(verified.id);
              variantInput.disabled = false;

              price.textContent = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: window.Shopify?.currency?.active || rowCurrency
              }).format(verified.price / 100);

              submit.disabled = false;
              cartStatus.textContent = '';
            })
            .catch(error => {
              if (token !== revision) return;

              cartStatus.textContent =
                error.message || 'Shopify configuration could not be verified';
              submit.disabled = true;
            });
        }

        selects.forEach(select =>
          select.addEventListener('change', update)
        );

        update();

        root.querySelector('[data-loading]').textContent =
          'Choose from the available catalog combinations.';

        form.addEventListener('submit', async event => {
          event.preventDefault();

          if (
            adding ||
            !selected ||
            !variant ||
            !form.reportValidity()
          ) return;

          const row = selected;
          const expected = variant;
          const token = revision;

          adding = true;
          submit.disabled = true;
          selects.forEach(select => select.disabled = true);
          area.querySelectorAll('button, [data-sku]').forEach(control =>
            control.disabled = true
          );

          cartStatus.textContent = 'Adding your configuration…';

          try {
            const verified = await commerce.resolve(row);

            if (
              token !== revision ||
              String(verified.id) !== String(expected.id)
            ) {
              throw Error('Configuration changed. Please select it again.');
            }

            if (verified.price !== expected.price) {
              variant = verified;

              root.querySelector('.dl-price').textContent =
                new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: window.Shopify?.currency?.active || rowCurrency
                }).format(verified.price / 100);

              root.querySelector('[data-confirm]').checked = false;

              throw Error(
                'The price changed. Please review the updated price before adding.'
              );
            }

            await commerce.add(verified, {
              '_Stuller SKU': row.sku,
              '_Stuller model': root.dataset.model,
'_Configuration image': row.images[0],
              'Metal': row.options['Quality'] || '',
              'Center stone shape': row.options['Primary Stone Shape'] || '',
              'Center stone size': row.options['Primary Stone Size'] || '',
              'Configuration': row.inclusionSummary,
              'Ring size (US)': root.querySelector('[data-ring-size]').value,
              'Order type': 'Made to order'
            });

            location.assign(
              (window.Shopify?.routes?.root || '/') + 'cart'
            );
          } catch (error) {
            cartStatus.textContent =
              error.message ||
              'Unable to add this configuration. Please try again.';
          } finally {
            adding = false;

            selects.forEach(select => select.disabled = false);
            area.querySelectorAll('button, [data-sku]').forEach(control =>
              control.disabled = false
            );

            submit.disabled = !variant;
          }
        });
      })
      .catch(() => {
        root.querySelector('[data-loading]').textContent =
          'Configurations could not load. Please refresh or call (813) 770-0484.';
        submit.disabled = true;
      });
  }

  const init = () =>
    document.querySelectorAll('[data-stuller]').forEach(mount);

  init();
  document.addEventListener('shopify:section:load', init);
})();